"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabPanels = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
/**
 * A `Tabs.Panels` component is the parent of a set of `Tabs.Panel` components
 * and a child of a `Tabs` component.
 *
 * @since 8.10.0
 */
var TabPanels = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "TabPanels",
  componentId: "c11n-8-107-0__sc-v8ly7k-0"
})([""]);
exports.TabPanels = TabPanels;
TabPanels.displayName = 'Tabs.Panels';

/** @component */